/**
 * Format file size in bytes to human readable format
 * Replacement for the tairo formatFileSize utility
 *
 * @param bytes - File size in bytes
 * @param si - Use SI units (1000) instead of binary (1024)
 * @param dp - Decimal places to show
 */
export function formatFileSize(bytes: number, si = true, dp = 1): string {
  const thresh = si ? 1000 : 1024

  if (Math.abs(bytes) < thresh) {
    return bytes + ' B'
  }

  const units = si
    ? ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
  let u = -1
  const r = 10 ** dp

  do {
    bytes /= thresh
    ++u
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh
    && u < units.length - 1
  )

  return bytes.toFixed(dp) + ' ' + units[u]
}
